<template>
	<div class="loadings.main">
		<div class="panel">
		小程序链接 :
		<span>/pages/active/info?activeId={{value._id}}</span>
		二维码：
		<div>
			<img :src="qr_code_url" v-if="qr_code_url"  class="img-thumbnail">
		</div>
		</div>
		<el-form
			ref="editorForm"
			:model="info"
			status-icon
			label-position="left"
			size="mini"
			v-loading="loadings.main"
			v-if="hasGetTableDataModel"
			@submit.native.prevent
			:rules="rules"
		>
			<div class="row">
				<div
					:class="key.col ? 'col-md-' + key.col : 'col-md-12'"
					v-for="(key, index) in fields"
					:key="index"
				>
					<el-form-item
						:label="tableDataModel[key.name].show_name + ' :'"
						:prop="key.name"
					>
						<field-show
							:width="key.width"
							v-model="info[key.name]"
							:field-info="tableDataModel[key.name]"
							:params="key.params"
						></field-show>
					</el-form-item>
				</div>
			</div>
		</el-form>
		<div class="footer" v-loading="loadings.formLoading">
			<el-button size="mini" type="primary" @click="goToEdit()">编辑</el-button>
		</div>
	</div>
</template>

<script>
import FieldEditor from "@/components/FieldEditor.vue";

export default {
	components: {},
	data() {
		return {
			loadings: {
				formLoading: false,
				main: false,
			},
			info: {},
			styles: [],
			everEdited: false,
			rules: {},
			qr_code_url:"",
			fields: [
				{
					name: "brand",
					rules: ["required"],
					width: "100%",
					col: 3,
				},
				{
					name: "name",
					rules: ["required"],
					width: "100%",
					col: 3,
				},
				{
					name: "price",
					rules: ["required"],
					width: "100%",
					col: 3,
				},
				{
					name: "status",
					rules: ["required"],
					width: "100%",
					col: 3,
				},
				{
					name: "type",
					col: 3,
					width: "100%",
				},

				// {
				// 	name: "amount",
				// 	col: 3,
				// },
				{
					name: "stores",
					col: 9,
					width: "100%",
				},
				{
					name: "colores",
					rules: ["required"],
					width: "100%",
					col: 3,
				},
				{
					name: "models",
					rules: ["required"],
					width: "100%",
					col: 9,
				},
				{
					name: "publish_at",
					col: 3,
					params: {
						type: "ts",
					},
				},

				{
					name: "sale_at",
					col: 3,
					params: {
						type: "ts",
					},
				},
				{
					name: "begin_at",
					col: 3,
					params: {
						type: "ts",
					},
				},
				{
					name: "end_at",
					col: 3,
					params: {
						type: "ts",
					},
				},
				{
					name: "primary_img",
					col: 12,
					// width: "100%"
				},

				{
					name: "desc_store",
					col: 12,
					// width: "100%"
				},
				{
					name: "desc_book",
					col: 12,
					// width: "100%"
				},
				{
					name: "desc_sale",
					col: 12,
					// width: "100%"
				},
				{
					name: "primary_imgs",
					col: 12,
					// width: "100%"
				},
				{
					name: "desc",
					col: 12,
					width: "100%",
					params: {
						row: 5,
					},
				},
			],
		};
	},
	props: {
		dataModel: {
			type: String,
			default: "",
		},
		hasGetTableDataModel: {
			type: Boolean,
			default: false,
		},
		value: {
			type: Object,
			default: () => {
				return {};
			},
		},
		tableDataModel: {
			type: Object,
			default: () => {
				return {};
			},
		},
		recordId: {
			type: String,
			default: "",
		},
		show: {
			type: Boolean,
			default: false,
		},
		name: {
			type: String,
			default: "name",
		},
	},
	mounted() {
		this.getQrCode();
	},
	computed: {},
	methods: {
		goToEdit() {
			this.$router.push({
				name: "Active-Edit",
				params: {
					id: this.recordId,
				},
			});
		},
		getQrCode() {
			this.$axios
			.get(`/active/gen_qr_code/${this.recordId}`)
			.then(json => {
				this.qr_code_url = json.data.info.qr_code;
			})
			.catch(json => {
				
			});
		}
	},
	watch: {
		value: {
			handler(val) {
				for (let i = 0; i < this.fields.length; i++) {
					let k = this.fields[i].name;
					this.$set(this.info, k, this.value[k]);
				}
			},
			immediate: true,
		},
	},
};
</script>
<style scoped>
.panel{
	margin:1em;
}
.img-thumbnail {
    padding: .25rem;
    background-color: #fff;
    border: 1px solid #dee2e6;
    border-radius: .25rem;
    max-width: 100%;
	height: auto;
	width:200px;
}
</style>
